var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniExercise02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.954346,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#D6895E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3224_13983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.954346,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#4A5294"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3224_13983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.622 242.896V223.099H190.388C194.886 223.099 197.47 225.875 197.47 229.771C197.47 233.722 194.845 236.443 190.279 236.443H186.724V242.896H182.622ZM186.724 233.135H189.622C192.056 233.135 193.245 231.767 193.232 229.771C193.245 227.802 192.056 226.476 189.622 226.463H186.724V233.135ZM201.435 243.142C200.15 243.142 199.111 242.117 199.138 240.845C199.111 239.588 200.15 238.562 201.435 238.576C202.652 238.562 203.704 239.588 203.704 240.845C203.704 242.117 202.652 243.142 201.435 243.142ZM207.04 242.896V223.099H214.806C219.304 223.099 221.888 225.875 221.888 229.771C221.888 233.722 219.263 236.443 214.697 236.443H211.142V242.896H207.04ZM211.142 233.135H214.04C216.474 233.135 217.663 231.767 217.65 229.771C217.663 227.802 216.474 226.476 214.04 226.463H211.142V233.135ZM228.45 223.099V242.896H224.404V223.099H228.45ZM238.322 243.197C233.769 243.183 230.98 240.244 230.993 235.541C230.98 230.961 233.81 227.857 238.157 227.857C242.054 227.857 245.13 230.318 245.13 235.377V236.525H234.986C234.986 238.767 236.312 240.148 238.404 240.162C239.784 240.148 240.769 239.547 241.165 238.658H245.021C244.447 241.406 241.986 243.183 238.322 243.197ZM234.986 233.982H241.302C241.288 232.177 240.044 230.879 238.24 230.892C236.38 230.879 235.068 232.273 234.986 233.982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.209,
    y: 193.305,
    width: 194.167,
    height: 14.2332,
    rx: 2,
    transform: "rotate(-47.2408 126.209 193.305)",
    fill: "#A1A6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.015 59.0539L259.502 52.1064C258.691 51.3565 257.426 51.406 256.676 52.217L253.469 55.685C253.323 55.8426 253.215 55.9992 253.125 56.1939C246.525 70.3623 205.818 128.182 174.764 161.764L267.126 61.8801C267.876 61.0691 267.826 59.8038 267.015 59.0539Z",
    fill: "#848F9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.215,
    y: 138.579,
    width: 45.9029,
    height: 15.1164,
    rx: 1,
    transform: "rotate(-47.2408 176.215 138.579)",
    fill: "#27435E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.979 138.135C117.168 137.385 117.119 136.12 117.869 135.309L129.208 123.046C129.958 122.235 131.224 122.185 132.035 122.935L206.359 191.662C207.17 192.412 207.219 193.677 206.469 194.488L195.13 206.751C194.38 207.562 193.115 207.612 192.304 206.862L117.979 138.135Z",
    fill: "#3C6C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.362 191.665L142.089 132.232L196.813 204.938L206.473 194.491C207.223 193.68 207.173 192.415 206.362 191.665Z",
    fill: "#2B4965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.474 161.242C111.663 160.492 111.614 159.226 112.363 158.415L125.061 144.684L185.227 200.319L172.53 214.051C171.78 214.862 170.515 214.911 169.704 214.161L112.474 161.242Z",
    fill: "#3C6C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.468 53.4019L222.165 39.6703C222.915 38.8593 224.181 38.8098 224.992 39.5597L282.221 92.4794C283.032 93.2293 283.082 94.4947 282.332 95.3057L269.635 109.037L209.468 53.4019Z",
    fill: "#3C6C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.332 62.0571C187.521 61.3071 187.471 60.0418 188.221 59.2308L199.561 46.9677C200.311 46.1567 201.576 46.1072 202.387 46.8571L276.711 115.584C277.522 116.334 277.572 117.599 276.822 118.41L265.482 130.673C264.733 131.484 263.467 131.534 262.656 130.784L188.332 62.0571Z",
    fill: "#3C6C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.227 200.315L130.785 149.972L174.209 212.23L185.227 200.315Z",
    fill: "#2B4965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.657 130.782L198.384 71.3492L275.144 120.224L265.483 130.671C264.734 131.482 263.468 131.532 262.657 130.782Z",
    fill: "#2B4965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.634 109.034L215.191 58.6917L280.652 97.1187L269.634 109.034Z",
    fill: "#2B4965"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniExercise02);
export default __webpack_public_path__ + "static/media/mini_exercise_02.c01cef0b68c01c7b2f0a206ca016b0ae.svg";
export { ForwardRef as ReactComponent };